import { render, staticRenderFns } from "./DetialOfSkill.vue?vue&type=template&id=a978aa30&scoped=true"
import script from "./DetialOfSkill.vue?vue&type=script&lang=js"
export * from "./DetialOfSkill.vue?vue&type=script&lang=js"
import style0 from "./DetialOfSkill.vue?vue&type=style&index=0&id=a978aa30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978aa30",
  null
  
)

export default component.exports